interface CarouselItem {
  image: string;
  title: string;
  tag: string;
  desc: string;
}

const CAROUSEL_ITEMS: CarouselItem[] = [
  {
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20action%20fantasy%20illustration%20with%20a%20powerful%20warrior%20in%20a%20dungeon%2C%20epic%20scale%2C%20dramatic%20color%20grading%2C%20warm%20orange%20and%20dark%20tone%2C%20professional%20webtoon%20promo%20banner%20style%2C%20clean%20background&width=1200&height=600&seq=carousel-01&orientation=landscape',
    title: '韩漫崛起：不可错过的10部爆款',
    tag: '编辑精选',
    desc: '从恋爱到奇幻，韩国网漫在全球掀起热潮，这些高人气作品你追了吗？',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Japanese%20shonen%20manga%20action%20scene%20with%20multiple%20characters%20in%20dynamic%20battle%20poses%2C%20vibrant%20energy%20effects%2C%20bold%20colors%2C%20professional%20manga%20magazine%20cover%20style%2C%20clean%20layout&width=1200&height=600&seq=carousel-02&orientation=landscape',
    title: '周刊少年Jump连载阵：最新速递',
    tag: '日漫专区',
    desc: '咒术回战、海贼王、电锯人……Jump系最火连载一网打尽，每周同步。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20epic%20fantasy%20illustration%20with%20traditional%20Chinese%20elements%2C%20martial%20arts%2C%20mystical%20creatures%2C%20ancient%20palace%20in%20background%2C%20dramatic%20composition%2C%20rich%20ink%20wash%20painting%20style%20blended%20with%20modern%20manhua&width=1200&height=600&seq=carousel-03&orientation=landscape',
    title: '国漫之光：一人之下领衔口碑神作',
    tag: '国漫专区',
    desc: '国漫质量逐年飞跃，这些高分神作代表了国产漫画的最高水准。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Romantic%20comedy%20manga%20illustration%20high%20school%20setting%20cherry%20blossoms%2C%20two%20teenagers%20shyly%20interacting%2C%20soft%20pink%20and%20warm%20tone%2C%20sweet%20atmosphere%2C%20professional%20shojo%20manga%20style&width=1200&height=600&seq=carousel-04&orientation=landscape',
    title: '恋爱漫画特辑：甜蜜到上头的佳作',
    tag: '主题推荐',
    desc: '脸红心跳的纯爱故事，治愈系恋爱漫画大盘点，承包你的少女心。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20suspense%20thriller%20manga%20illustration%20mysterious%20urban%20alleyway%2C%20shadowy%20figures%2C%20neon%20lighting%2C%20tense%20atmosphere%2C%20professional%20seinen%20manga%20style%2C%20cinematic%20composition&width=1200&height=600&seq=carousel-05&orientation=landscape',
    title: '悬疑烧脑漫画推荐：反转再反转',
    tag: '主题推荐',
    desc: '喜欢动脑的读者必看！这些剧情反转的神作漫画，每一话都让人猜不到结局。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Comedy%20slice%20of%20life%20manga%20illustration%20everyday%20funny%20scenes%20with%20exaggerated%20facial%20expressions%2C%20bright%20cheerful%20colors%2C%20playful%20tone%2C%20professional%20gag%20manga%20style%2C%20clean%20background&width=1200&height=600&seq=carousel-06&orientation=landscape',
    title: '搞笑漫画合集：笑到停不下来',
    tag: '主题推荐',
    desc: '压力大的时候来一部搞笑漫画吧！这些笑点密集的神作保证让你笑出腹肌。',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-50 scroll-mt-[72px]">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">焦点专题</h2>
          <p className="text-foreground-500 text-sm mt-3">精心策划的漫画专题合集，发现更多精彩内容</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {CAROUSEL_ITEMS.map((item) => (
            <div
              key={item.title}
              className="group bg-background-100 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute bottom-3 left-3">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-background-50/90 text-foreground-700 font-medium backdrop-blur-sm">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}